var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ params: { selectedBullet: _vm.index }  }}},[_c('div',{staticClass:"bullet",style:('left: ' + _vm.x + '%; ' + 'top: ' + _vm.y + '%')},[_c('span',{staticClass:"bullet__label"},[_vm._v(_vm._s(_vm.index + 1))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c547cb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bullet.vue
// module id = null
// module chunks = 